import React, { Fragment, memo } from "react";
import moment from "moment";
import "moment/locale/es";
import { InView } from "react-intersection-observer";
import { PLAN_GRID_VIEWS } from "components/Plans";
import { expandWorkingHoursListForPreview, getPreviewForPlanDay } from "components/Plans/hourlyShiftResize";

const formatPlanWeekday = (day) =>
	moment(day).format("ddd").replace(/\./g, "").toUpperCase();

const getDayTypeColor = (day) => {
	const details = day?.details;
	let dayType;
	if (details?.length > 0) {
		if (details[0].special_day) dayType = details[0].special_day.day_type;
		if (details[0].weekday) dayType = details[0].weekday.day_type;
	}
	return dayType?.color || null;
};

// plan table render
const getPlanHeader = (props) =>
	props.plan_days.map((d, i) => {
		const weekday = formatPlanWeekday(d.day);
		const dayNum = moment(d.day).format("D");
		const color = getDayTypeColor(d);
		const isToday = moment(d.day).isSame(moment(), "day");

		return (
			<InView
				as="th"
				className={`th-day th-selectable${isToday ? " today" : ""}`}
				key={i}
				onChange={(inView, entry) =>
					props.changeMonthHeader(inView, entry, d.day)
				}
				onClick={() => props.handleColumnSelection(i)}
			>
				<div className="th-wrap">
					<span className="span-day">{weekday}</span>
					<span
						className="span-num"
						style={!isToday && color ? { color } : undefined}
					>
						{dayNum}
					</span>
				</div>
			</InView>
		);
	});

// plan table render
const getPlanHourlyHeader = (props) =>
	props.plan_days.map((d, i) => {
		//console.log(props);

		const day = formatPlanWeekday(d.day);
		const dayNum = moment(d.day).format("D");
		const color = getDayTypeColor(d);
		const isToday = moment(d.day).isSame(moment(), "day");

		return (
			<Fragment key={i}>
				<InView
					as="th"
					className={`th-day head-hours-main ${isToday ? "today" : ""}`}
					// style={{ color: color }}
					style={{ backgroundColor: "#f7f7f8", border: "none" }}
					onChange={(inView, entry) =>
						props.changeMonthHeader(inView, entry, d.day)
					}
				>
					<div className="th-wrap">
						<span className="span-day">{day}</span>
						<span
							className="span-num"
							style={!isToday && color ? { color } : undefined}
						>
							{dayNum}
						</span>
					</div>
				</InView>
				{getPlanHourlyRows(props, i)}
			</Fragment>
		);
	});

// old: 	{h}-{h + 1}
const getDayWorkingHoursList = (props, dayIndex) => {
	const perDay =
		props.plan_assignments?.[0]?.plans?.[dayIndex]?.working_hours_list;
	let list =
		perDay?.length > 0 ? perDay : props.working_hours_list || [];

	const preview = props.resizePreview;
	const planDay = props.plan_days?.[dayIndex]?.day;
	const dayPreview = getPreviewForPlanDay(preview, planDay);
	if (dayPreview?.previewStart && dayPreview?.previewEnd) {
		list = expandWorkingHoursListForPreview(
			list,
			dayPreview.previewStart,
			dayPreview.previewEnd
		);
	}

	return list;
};

const getPlanHourlyRows = (props, dayIndex) =>
	getDayWorkingHoursList(props, dayIndex).map((h, i) => (
		<th className="head-hours" key={i}>
			{h}h
		</th>
	));

const PlanTableHead = (props) => {
	const monthName = moment(props.current_month).format("MMMM");
	const year = moment(props.current_month).format("YYYY");
	//console.log(props);
	if (props.plan_assignments.length === 0) return "";
	// console.log(props.plan_grid_view);
	return (
		<thead>
			<tr>
				<th className="th-day">
					<div className="th-wrap">
						<span className="span-month">{monthName}</span>
						<span className="span-year">{year}</span>
					</div>
				</th>
				{props.plan_grid_view === PLAN_GRID_VIEWS.hours
					? getPlanHourlyHeader(props)
					: getPlanHeader(props)}
			</tr>
		</thead>
	);
};

const previewHeaderKey = (preview) => {
	if (!preview?.previewStart || !preview?.previewEnd || !preview?.day) {
		return null;
	}
	return `${preview.day}|${preview.previewStart}|${preview.previewEnd}`;
};

const planTableHeadPropsAreEqual = (prev, next) => {
	if (prev.plan_grid_view !== next.plan_grid_view) return false;
	if (prev.current_month !== next.current_month) return false;
	if (prev.plan_days !== next.plan_days) return false;
	if (prev.working_hours_list !== next.working_hours_list) {
		const a = prev.working_hours_list;
		const b = next.working_hours_list;
		if (!a || !b || a.length !== b.length) return false;
		for (let i = 0; i < a.length; i++) {
			if (a[i] !== b[i]) return false;
		}
	}
	if (prev.plan_assignments !== next.plan_assignments) {
		// Cabecera horaria solo depende de la rejilla del primer empleado.
		const prevFirst = prev.plan_assignments?.[0];
		const nextFirst = next.plan_assignments?.[0];
		if (prevFirst !== nextFirst) return false;
	}
	if (
		previewHeaderKey(prev.resizePreview) !==
		previewHeaderKey(next.resizePreview)
	) {
		return false;
	}
	return true;
};

export default memo(PlanTableHead, planTableHeadPropsAreEqual);
